import React, { useState, useEffect } from 'react'
import { postAPI } from '../../../app/api';
import aboutImg from "../../../assets/img/history-img.jpg"
import UseParticles from './UseParticles';
// HTML Assets Base URL
const HTML_ASSETS_URL = 'https://retechprime.com/be-college-ex-students-club/html/';

export default function AboutInfoAccordion() {
    const [aboutSections, setAboutSections] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAboutSections();
    }, []);

    const fetchAboutSections = async () => {
        try {
            setLoading(true);
            const response = await postAPI('about/listPublished', { page: 'ABOUT' });
            if (response?.status === 1) {
                setAboutSections(response?.data || []);
            }
        } catch (error) {
            console.error('Error fetching about sections:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <section className="about py-5">
                <div className="container-xxl container-xl container-fluid">
                    <div className="text-center py-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!aboutSections || aboutSections.length === 0) {
        return null;
    }

    return (
        <>

        <section className='tst'>
        <UseParticles />
        <div className='container'>
        <div className="mid-head"><h3 className="mb-20"><span className="yelloowtext"> Bengal Engineering College </span>, popularly known as <span className="yelloowtext"> B E College, Shibpur </span>, has been serving the nation since 1856 and stands as one of the oldest engineering institutions in the country. Through nearly two centuries of excellence, the institution has gracefully adapted to technological advancements while remaining steadfast in its commitment to academic and societal progress. <br /> <br />
        In recognition of its academic stature and national importance, the institution has since been elevated to the status of the
         <span className="yelloowtext"> Indian Institute of Engineering Science and Technology (IIEST), Shibpur</span> , further strengthening its role as a centre of excellence in engineering education and research. A defining hallmark of the institution is its rich heritage and the enduring bond shared among its alumni. This strong sense of togetherness, pride, and camaraderie continues to unite generations of graduates, reinforcing its legacy and shaping its future.</h3></div>
        </div>
        </section>
        {/* <section className='prcl'>
            <div className="bepopular">
                <div className='mid-head'>
        <h3 className='mb-20'><span className="yelloowtext"> Bengal Engineering College </span>, popularly known as B E College, Shibpur, has been serving the nation since 1856 and stands as one of the oldest engineering institutions in the country. Through nearly two centuries of excellence, the institution has gracefully adapted to technological advancements while remaining steadfast in its commitment to academic and societal progress. </h3>

<h3> A defining hallmark of <span className="yelloowtext"> B E College </span> is its rich heritage and the enduring bond shared among its alumni. This strong sense of togetherness, pride, and camaraderie continues to unite generations of graduates, reinforcing the institution’s legacy and shaping its future.</h3>
</div>
            </div>
           </section> */}
            <section className="about py-5">
                <div className="container-xxl container-xl container-fluid">
                    <div className="row align-items-lg-center align-items-md-start justify-content-lg-between justify-content-md-between justify-content-center">
                        <div className="col-lg-5 col-md-4 col-sm-8 mb-4 text-lg-start text-md-start text-center about-img">
                            <img
                                src={aboutImg}
                                className="img-fluid rounded-4"
                                alt="About BE College"
                            />
                        </div>
                        <div className="col-lg-7 col-md-8">
                            <div className="d-flex">
                                <div className="flex-grow-1">
                                    {/* <div className="accordion custom-accordion" id="infoAccordion">
                                        {aboutSections.map((section, index) => (
                                            <div className="accordion-item" key={section.id || index}>
                                                <div className="vertical-line"></div>
                                                <h2 className="accordion-header">
                                                    <button
                                                        className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#item${index + 1}`}
                                                    >
                                                        <span className="fw-bold d-flex align-items-center">
                                                            <div className="steps-list">{String(index + 1).padStart(2, '0')}</div>
                                                            {section.section_name}
                                                        </span>
                                                    </button>
                                                </h2>
                                                <div
                                                    id={`item${index + 1}`}
                                                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                                    data-bs-parent="#infoAccordion"
                                                >
                                                    <div className="accordion-body">
                                                        <p>{section.content}</p>
                                                        <a href="/about" className="read-more">READ MORE</a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div> */}
                                    <div className="accordion custom-accordion" id="infoAccordion">
                                        <div className="accordion-item">
                                            <div className="vertical-line"></div>
                                            <h2 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#item1">
                                                    <span className="fw-bold d-flex align-items-center">
                                                        <div className="steps-list">01</div>Our History
                                                    </span>
                                                </button>
                                            </h2>
                                            <div id="item1" className="accordion-collapse collapse show"
                                                data-bs-parent="#infoAccordion">
                                                <div className="accordion-body">
                                                    <p className=""><strong>Founded in 1986,</strong> B E College Ex Students Club grew into a registered alumni body, built its own premises, promoted culture, community, skilling, and celebrated milestones including a Silver Jubilee celebrations.</p>
                                                    <a href="/about" className="read-more">READ MORE</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <div className="vertical-line"></div>
                                            <h2 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#item2">
                                                    <span className="fw-bold d-flex align-items-center">
                                                        <div className="steps-list">02</div>Our Preamble
                                                    </span>
                                                </button>
                                            </h2>
                                            <div id="item2" className="accordion-collapse collapse" data-bs-parent="#infoAccordion">
                                                <div className="accordion-body">
                                                    <p>The Preamble of the B E College Ex-Students' Club sets forth the founding purpose, spirit, and principles upon which the Association was established. It outlines the intent and objectives that continue to guide the functioning and activities of the Club.</p>
                                                    <a href="/about" className="read-more">READ MORE</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <div className="vertical-line"></div>
                                            <h2 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#item3">
                                                    <span className="fw-bold d-flex align-items-center">
                                                        <div className="steps-list">03</div>Our Objectives
                                                    </span>
                                                </button>
                                            </h2>
                                            <div id="item3" className="accordion-collapse collapse" data-bs-parent="#infoAccordion">
                                                <div className="accordion-body">
                                                    <p>The Objectives of the B. E. College Ex-Students' Club define the aims and purposes for which the Association has been established. They set out the guiding framework for the Club's social, cultural, educational, charitable, and administrative activities, and govern the manner in which its resources are applied.</p>
                                                    <a href="/about" className="read-more">READ MORE</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <div className="vertical-line"></div>
                                            <h2 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#item4">
                                                    <span className="fw-bold d-flex align-items-center">
                                                        <div className="steps-list">04</div>Our Infrastructure
                                                    </span>
                                                </button>
                                            </h2>
                                            <div id="item4" className="accordion-collapse collapse" data-bs-parent="#infoAccordion">
                                                <div className="accordion-body">
                                                    <p><strong>Bengal Engineering College</strong>popularly known as <strong>B E College, Shibpur</strong>, has been serving the nation since 1856 and stands as one of the oldest engineering institutions in the country. Through nearly two centuries of excellence, the institution has gracefully adapted to technological advancements while remaining steadfast in its commitment to academic and societal progress.In recognition of its academic stature and national importance, the institution has since been elevated to the status of the <strong> Indian Institute of Engineering Science and Technology (IIEST), Shibpur</strong> r, further strengthening its role as a centre of excellence in engineering education and research. A defining hallmark of the institution is its rich heritage and the enduring bond shared among its alumni. This strong sense of togetherness, pride, and camaraderie continues to unite generations of graduates, reinforcing its legacy and shaping its future.</p>
                                                    <a href="/infrastructure" className="read-more">READ MORE</a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}